module.exports = __webpack_public_path__ + "img/content-title-zh.f0e6b983.png";